import { UpdateSiteLocalisation } from '../editSite/updateSiteLocalisation';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import { useState } from 'react';
import '../../../css/sites/siteLocalisation.css';

const SiteLocalisation = () => {

    const siteDetailsData = useSelector((state) => state.SiteDetailsData || {});
    const hasSiteUpdatePermission = useHasPermission('site_update');
    const [openUpdateLocalisation, setOpenUpdateLocalisation] = useState(false);

    const handleEditClick = () => setOpenUpdateLocalisation(true);

    return (
        <Box className='SiteLocalisation_main_box'>

            <Box className='SiteLocalisation_box'>
                <Box className='localisation_edit_box'>
                    <Typography className='SiteLocalisation_title'>Localisation et rattachement</Typography>
                    {hasSiteUpdatePermission && <Iconify className='SiteLocalisation_edit_icon' icon={"ic:outline-edit"} onClick={handleEditClick} />}
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"oui:vis-map-region"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Region: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{siteDetailsData?.region?.name}</Typography>
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"hugeicons:address-book"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Adresse: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{siteDetailsData?.address || '--'}</Typography>
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"hugeicons:address-book"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Complément d'adresse: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{siteDetailsData?.address_line_2 || '--'}</Typography>
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"mdi:address-marker-outline"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Postal code: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{siteDetailsData?.postal_code || '--'}</Typography>
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"ph:city"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Ville: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{siteDetailsData?.city || '--'}</Typography>
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"mdi:telephone"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Numéro Tel: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{siteDetailsData?.phone_number || '--'}</Typography>
                    </Box>
                </Box>
            </Box>

            {openUpdateLocalisation &&
                <UpdateSiteLocalisation
                    openUpdateLocalisation={openUpdateLocalisation}
                    setOpenUpdateLocalisation={setOpenUpdateLocalisation}
                />
            }

        </Box>
    );
}

export default SiteLocalisation;